import React, { Component } from 'react';
import ChangeProfileInfo from './ChangeProfileInfo';
import $ from 'jquery';
import logout from '../login/Logout';

class MyAccount extends Component {
    constructor() {
        super();
        this.state = {
            disableFullName: true,
            disableEmail: true,
            disableMobileNum: true,
            disableOrgName: true,
            disableAddress: true,
            fields: {},
            errors: {},
            showStore: false
        }
    };

    componentDidMount() {
        setTimeout(() => {
            this.userAccount();
        }, 300);
        let signupdata = JSON.parse(localStorage.getItem("user_details"));
        let fields = this.state.fields;
        fields["fullname"] = signupdata["name"]
        fields["email"] = signupdata["emailId"]
        fields["mobileNumber"] = signupdata["mobileNumber"]
        fields["organizationName"] = signupdata["organizationName"]
        fields["address"] = signupdata["address"]
        this.setState({ fields });
    }

    userAccount = () => {
        $.ajax({
            url: "/api/user-account/me",
            async: false,
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    localStorage.setItem("user_details", JSON.stringify(res.result));
                }
            }
        });
    }

    showChangePwd = () => {
        this.setState({ showStore: true });
    }

    closeChangePwd = () => {
        this.setState({ showStore: false });
        this.myFormRef.reset();
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({ fields });
    }

    handleFullnameChange = (e) => {
        this.setState({ fullname: e.target.value });
    }

    changeFullName = (e) => {
        this.setState({ disableFullName: !this.state.disableFullName });

        if (e.target.text == "Save") {
            let data = { "emailId": this.state.fields.email, "name": this.state.fields.fullname };
            let url = "/api/user-account/change-name";
            ChangeProfileInfo(data, url);
        }
    }

    changeAddress = (e) => {
        this.setState({ disableAddress: !this.state.disableAddress });

        if (e.target.text == "Save") {
            let url = "/api/user-account/change-address";
            let data = { "emailId": this.state.fields.email, "address": this.state.fields.address };
            ChangeProfileInfo(data, url);
        }
    }

    changeOrganizationName = (e) => {
        this.setState({ disableOrgName: !this.state.disableOrgName });

        if (e.target.text == "Save") {
            let url = "/api/user-account/change-organization-name";
            let data = { "emailId": this.state.fields.email, "organizationName": this.state.fields.organizationName }
            ChangeProfileInfo(data, url);
        }
    }

    changePasswordApi = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            let myAccountController = this;
            let errors = {};
            let data = { "emailId": this.state.fields.email, "oldPassword": this.state.fields.oldPassword, "newPassword": this.state.fields.newPassword }
            myAccountController.myFormRef.reset();
            $.ajax({
                url: "/api/change-password",
                type: 'POST',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                async: false,
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        myAccountController.setState({ showStore: false });
                        logout();
                    } else {
                        myAccountController.setState({ disableOtp: true });
                        errors["response"] = res.result;
                        myAccountController.setState({
                            errors: errors
                        });
                    }
                }
            });
        }
    }

    changeMobileNumber = (e) => {
        this.setState({ disableMobileNum: !this.state.disableMobileNum });
        let url = "";

        if (e.target.text == "Save") {
            ChangeProfileInfo(this.state.data, url);
        }
    }

    changeEmail = (e) => {
        this.setState({ disableEmail: !this.state.disableEmail });

        if (e.target.text == "Save") {
            let url = "";
            ChangeProfileInfo(this.state.data, url);
        }
    }

    validateForm = () => {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["oldPassword"]) {
            errors["oldPassword"] = "*Please enter your old password";
        }

        if (!fields["newPassword"]) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof fields["newPassword"] !== "undefined") {
            if (!fields["newPassword"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        if (fields["newPassword"] !== fields["confirmPassword"]) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateNewPwd = () => {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["newPassword"]) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof fields["newPassword"] !== "undefined") {
            if (!fields["newPassword"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateConfirmPwd = () => {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (fields["newPassword"] !== fields["confirmPassword"]) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateOldPwd = () => {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["oldPassword"]) {
            formIsValid = false;
            errors["oldPassword"] = "*Please enter your old password";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    render() {
        return (
            <div >
                <div className="wrapper" style={{ height: "510px" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-8">
                                <h1 className="m-0 page-title">My Account</h1>
                                <h6 className="taglineTxt"></h6>
                            </div>
                            <div className="col-sm-4 p-0">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <div className="p-2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">

                                    <div className="col-12">
                                        {/* /.card-header */}
                                        <div className="card-body p-0">
                                            <div className="col-lg-12 col-md-12 account-details">
                                                <div className="col-md-4">Basic Details</div>

                                                <input type="text" disabled={this.state.disableFullName} onChange={this.handleChange}
                                                    style={{ borderBottomColor: this.state.disableFullName ? "#FFFFFF" : "#b2beb5" }}
                                                    defaultValue={this.state.fields.fullname} className="col-md-4" name="fullname" />
                                                <a className="col-md-4 linktxt" style={{ cursor: "pointer" }} onClick={this.changeFullName}>{this.state.disableFullName ? "Change Full Name" : "Save"}</a>
                                            </div>
                                            <div className="col-lg-12 col-md-12 account-details">
                                                <div className="col-md-4" />

                                                <input type="text" disabled={this.state.disableEmail} onChange={this.handleChange}
                                                    style={{ borderBottomColor: this.state.disableEmail ? "#FFFFFF" : "#b2beb5" }}
                                                    defaultValue={this.state.fields.email} className="col-md-4" name="email" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 account-details border-bottom">
                                                <div className="col-md-4" />

                                                <input type="text" disabled={this.state.disableMobileNum} onChange={this.handleChange}
                                                    style={{ borderBottomColor: this.state.disableMobileNum ? "#FFFFFF" : "#b2beb5" }}
                                                    defaultValue={this.state.fields.mobileNumber} className="col-md-4" name="mobileNumber" />

                                            </div>
                                            <div className="col-lg-12 col-md-12 account-details">
                                                <div className="col-md-4">Additional Details</div>

                                                <input type="text" disabled={this.state.disableOrgName} onChange={this.handleChange}
                                                    style={{ borderBottomColor: this.state.disableOrgName ? "#FFFFFF" : "#b2beb5" }}
                                                    defaultValue={this.state.fields.organizationName} className="col-md-4" name="organizationName" />
                                                <a className="col-md-4 linktxt" style={{ cursor: "pointer" }} onClick={this.changeOrganizationName}>{this.state.disableOrgName ? "Change Organisation Name" : "Save"}</a>
                                            </div>
                                            <div className="col-lg-12 col-md-12 account-details border-bottom">
                                                <div className="col-md-4" />
                                                <input type="text" disabled={this.state.disableAddress} onChange={this.handleChange}
                                                    style={{ borderBottomColor: this.state.disableAddress ? "#FFFFFF" : "#b2beb5" }}
                                                    defaultValue={this.state.fields.address} className="col-md-4" name="address" />
                                                <a className="col-md-4 linktxt" style={{ cursor: "pointer" }} onClick={this.changeAddress}>{this.state.disableAddress ? "Change Address" : "Save"}</a>
                                            </div>
                                            <div className="col-lg-12 col-md-12 account-details">
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    <div className="col-md-12 p-0">
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <button type="button" className="btn btn-primary btn-block pull-right" style={{ width: "150px", fontSize: '16px' }} onClick={this.showChangePwd}>Change Password</button></div>
                                            </div>

                                        </div>
                                        {/* /.tab-content */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="wrapper">
                    <div className="modal" style={{ display: this.state.showStore ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-password-modal">
                            <div className="modal-content" style={{ height: "auto", width: "500px" }}>
                                <div className="modal-header noBorder" style={{ height: '39px' }}>
                                    <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeChangePwd}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form ref={(el) => this.myFormRef = el}>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Old Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="oldPassword" className="form-control-plaintext" onChange={this.handleChange} onBlur={this.validateOldPwd} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.oldPassword}</span>
                                        </div> <br />
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">New Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="newPassword" className="form-control-plaintext" onBlur={this.validateNewPwd} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword} </span>
                                        </div> <br />
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Confirm Password</label>
                                            <div className="col-sm-8">
                                                <input type="password" name="confirmPassword" className="form-control-plaintext" onBlur={this.validateConfirmPwd} onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.confirmPassword}</span>
                                        </div> <br />
                                        <div className="modal-footer noBorder">
                                            <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.changePasswordApi}>Done</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}
export default MyAccount;


// WEBPACK FOOTER //
// ./src/sales-desk/header/MyAccount.js